import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function FlexContainer(props) {
  const { children, hasMaxWidth, className, ...rest } = props;

  const classes = cx("flex-container-fluid", {
    "flex-container-has-max-width": hasMaxWidth
  })

  return (
    <div
      className={cx(classes, className)}
      data-component="FlexContainer"
      {...rest}>
      {children}
    </div>
  );
}

FlexContainer.propTypes = {
  children: PropTypes.node.isRequired,
  hasMaxWidth: PropTypes.bool,
  className: PropTypes.string
};

FlexContainer.defaultProps = {
  hasMaxWidth: false
};